import {
    CLEAR,
    BILLING_LIST_REQUEST,
    BILLING_LIST_SUCCESSFUL,
    BILLING_LIST_FAILED,
    BILLING_SET_FILTER,
    GET_ONGOING_TRIP_RECEIPTS,
    SET_ONGOING_TRIP_RECEIPTS_LOADING,
    SET_ONGOING_TRIP_RECEIPTS,
} from './types';

export const clear = () => ({ type: CLEAR });
export const billingListRequest = () => ({ type: BILLING_LIST_REQUEST });
export const billingListSuccessful = data => ({ type: BILLING_LIST_SUCCESSFUL, payload: data });
export const billingListFailed = () => ({ type: BILLING_LIST_FAILED });
export const billingSetFilter = (year, month, profile) => ({
    type: BILLING_SET_FILTER,
    payload: { year, month, profile },
});

export const getOngoingTripReceipts = () => ({
    type: GET_ONGOING_TRIP_RECEIPTS,
});
/**
 * @param {boolean} loading - Indicates if the ongoing trip receipts are loading
 * @returns {void}
 */
export const setOngoingTripReceiptsLoading = loading => ({
    type: SET_ONGOING_TRIP_RECEIPTS_LOADING,
    payload: loading,
});
/**
 * Sets the ongoing trip receipts in the store
 * @param {Record<string, Record<string, object>>} data - The ongoing trip receipts data
 *   where keys are trip IDs and values are objects containing receipt objects
 *   Example structure:
 *   {
 *     "tripIdA": {
 *       receiptA: {},
 *       receiptB: {},
 *     },
 *     "tripIdB": {
 *       receiptA: {},
 *       receiptB: {},
 *       receiptC: {},
 *     }
 *   }
 * @returns {Object} Action object with the receipt data as payload
 */
export const setOngoingTripReceipts = data => ({
    type: SET_ONGOING_TRIP_RECEIPTS,
    payload: data,
});
